interface MergeableSourceTarget {
  patient_id?: number;
  clinic_id?: number;
  highlight?: unknown;
  subsection?: string;
}

interface MergeableSourceCandidate {
  snippet?: string;
  patient_id?: number;
  clinic_id?: number;
  patient_display?: string;
  document_ref?: unknown;
  target: MergeableSourceTarget;
}

/**
 * Combine repeated copies of one source without discarding fields that only
 * one producer supplied. Prefer the richer copy for conflicting core fields.
 */
export const mergeNeoSourceCandidate = <T extends MergeableSourceCandidate>(
  existing: T | undefined,
  candidate: T
): T => {
  if (!existing) return candidate;

  const candidateIsRicher =
    (!existing.snippet && !!candidate.snippet) ||
    (existing.patient_id == null && candidate.patient_id != null) ||
    (existing.clinic_id == null && candidate.clinic_id != null) ||
    (!existing.patient_display && !!candidate.patient_display) ||
    (existing.document_ref == null && candidate.document_ref != null);
  const preferred = candidateIsRicher ? candidate : existing;
  const fallback = candidateIsRicher ? existing : candidate;

  return {
    ...fallback,
    ...preferred,
    snippet: preferred.snippet ?? fallback.snippet,
    patient_id: preferred.patient_id ?? fallback.patient_id,
    clinic_id: preferred.clinic_id ?? fallback.clinic_id,
    patient_display: preferred.patient_display ?? fallback.patient_display,
    document_ref: preferred.document_ref ?? fallback.document_ref,
    target: {
      ...fallback.target,
      ...preferred.target,
      patient_id: preferred.target.patient_id ?? fallback.target.patient_id,
      clinic_id: preferred.target.clinic_id ?? fallback.target.clinic_id,
      highlight: preferred.target.highlight ?? fallback.target.highlight,
      subsection: preferred.target.subsection ?? fallback.target.subsection,
    },
  };
};
